<template>
  <v-card
    class="mx-auto"
 
   
  >
    <v-card-title class="title font-weight-regular justify-space-between">
      <span>{{ currentTitle }}</span>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="step"
      ></v-avatar>
    </v-card-title>

    <v-window style="width:90vw" v-model="step">
      
        <v-window-item :value="1">
          <div v-show="active"> 
            <v-item-group>
              <v-container grid-list-lg>
                <v-layout wrap>
                   <v-list two-line>
                    <template>
                      <v-list-tile class="elevation-4" @click="step++; token = false; database = true">
                        <v-list-tile-avatar>
                          <!-- <img :src="https://cdn.vuetifyjs.com/images/logos/v.svg"> -->
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <v-list-tile-title>Database</v-list-tile-title>
                          <v-list-tile-sub-title>A database style contract</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
    <!-- spacer --> <span style="margin:20px;"></span>
                      <v-list-tile class="elevation-4" @click="step++; token = true; database = false">
                        <v-list-tile-avatar>
                          <!-- <img :src="https://cdn.vuetifyjs.com/images/logos/v.svg"> -->
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <v-list-tile-title>Tradable asset</v-list-tile-title>
                          <v-list-tile-sub-title>A token style contract</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-layout>
              </v-container>
            </v-item-group>
          </div>
        </v-window-item>            
        <v-window-item :value="2">
            <div v-show="active">
              <v-card-text>
                <TableBuilder  v-if="database"/>
              </v-card-text>

              <v-card-text v-if="token">
                <v-text-field
                  style="max-width:200px; margin-bottom:40px;"
                  label="Symbol (SYM)"
                  type="text"
                ></v-text-field>
                <span class="caption grey--text text--darken-1">
                  Please enter a symbol for your account
                </span>
              </v-card-text>
            </div>
          </v-window-item>
          <v-window-item :value="3">
            <div v-show="active">
              <div v-if="database">
                <!-- <h2>
                  Add contract details - costs -etc
                </h2> -->
                <v-tooltip >
                  <v-btn
                    style="margin:40px"
                    slot="activator"
                    
                    @click="deployDbContract();"
                  >
                    <v-icon >deploy</v-icon>
                  </v-btn>
                  <span>deploy contract to the blockchain</span>
                </v-tooltip>
              </div>
              <div v-if="token">
                <h2>
                  Add contract details - costs -etc
                </h2>
                <v-tooltip >
                  <v-btn
                    slot="activator"
                    
                    @click="deployTokenContract();"
                  >
                    <v-icon >deploy</v-icon>
                  </v-btn>
                  <span>deploy contract to the blockchain</span>
                </v-tooltip>
              </div>
              <br/>
              <br/>
              <v-btn flat small color="primary">COPY</v-btn>

              <pre ><code  class="javascript">
                ScatterJS.scatter.connect('My-App').then(connected => {

                  
                  if(!connected) return false;

                  const scatter = ScatterJS.scatter;

                  const requiredFields = { accounts:[network] };
                  scatter.getIdentity(requiredFields).then(() => {

                      eos.setcode(account.name, 0, 0, Buffer.from(wasm.data), transactionOptions).then(trx => {
             
                      }).catch(error => {
                          console.error(error);
                      });

                  }).catch(error => {

                      console.error(error);
                  }
                  </code></pre>
               
              <h3 ></h3>
              <span></span>
            </div>
        </v-window-item>

      </div>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1"
        flat
        @click="step--"
      >
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="step === 6 || step === 1"
        color="primary"
        depressed
        @click="step++"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import TableBuilder from './TableBuilder.vue'
  import ScatterJS from 'scatterjs-core';
  import ScatterEOS from 'scatterjs-plugin-eosjs';

  import Eos from 'eosjs';
  import axios from 'axios';

  // Don't forget to tell ScatterJS which plugins you are using.
  ScatterJS.plugins( new ScatterEOS() );

  // Networks are used to reference certain blockchains.
  // They let you get accounts and help you build signature providers.
  const network = {
      blockchain:'eos',
      protocol:'https',
      host:'jungle2.cryptolions.io',
      port:443,
      chainId:'e70aaab8997e1dfce58fbfac80cbbb8fecec7b99cf982a9444273cbc64c41473'
  }


  export default {
    data: () => ({
      step: 2,
      token: false,
      database: true,
      active: true
    }),
    components: {
      TableBuilder
    },
    created: function () {
      // this.secureDatastoreDeploy()
    },

    computed: {
      currentTitle () {
        switch (this.step) {
          case 1: return 'Choose a contract type'
          case 2: return 'Customize your contract'
          default: return 'Deploy it to the blockchain'
        }
      }
    },
    watch: {
      step () {
        this.$router.push(this.step)
        // let self = this
        // setTimeout(function(){ self.active = true }, 1000);
        // setTimeout(function(){ self.active = false }, 250);

        // if (this.step == 2 || this.step == 4) {
        //   setTimeout(function(){ self.step == 10 }, 500);
        // }
      }
    },
    methods: {
      deployDbContract: async function () {
        // this.$store.dispatch('contractBuild/prepareContractCodes')
        // this.$store.dispatch('contractBuild/deployContract')
        try {
            await this.$store.dispatch('contractBuild/prepareContractCode')
            this.$store.dispatch('contractBuild/deployContract')
        } catch (err) {
            console.log(err)
        }
      },
      deployTokenContract: async function () {
        // this.$store.dispatch('contractBuild/prepareContractCodes')
        // this.$store.dispatch('contractBuild/deployContract')
        try {
            await this.$store.dispatch('contractBuild/prepareContractCode')
            this.$store.dispatch('contractBuild/deployContract')
        } catch (err) {
            console.log(err)
        }
      }
      // secureDatastoreDeploy: function () {
      //   let wasm
      //   let abi

      //   axios
      //     .get('http://127.0.0.1:3001/getDatastoreWasm')
      //     .then(response => (wasm = response))
      //     .then(axios.get('http://127.0.0.1:3001/getDatastoreAbi')
      //     .then(response => (abi = response)))
      //     .then(ScatterJS.scatter.connect('My-App').then(connected => {

      //       // If the user does not have Scatter or it is Locked or Closed this will return false;
      //       if(!connected) return false;

      //       const scatter = ScatterJS.scatter;

      //       // Now we need to get an identity from the user.
      //       // We're also going to require an account that is connected to the network we're using.
      //       const requiredFields = { accounts:[network] };
      //       scatter.getIdentity(requiredFields).then(() => {

      //           // Always use the accounts you got back from Scatter. Never hardcode them even if you are prompting
      //           // the user for their account name beforehand. They could still give you a different account.
      //           const account = scatter.identity.accounts.find(x => x.blockchain === 'eos');

      //           // You can pass in any additional options you want into the eosjs reference.
      //           const eosOptions = { expireInSeconds:60 };

      //           // Get a proxy reference to eosjs which you can use to sign transactions with a user's Scatter.
      //           const eos = scatter.eos(network, Eos, eosOptions);

      //           // Never assume the account's permission/authority. Always take it from the returned account.
      //           const transactionOptions = { authorization:[`${account.name}@${account.authority}`] };

      //           eos.setcode(account.name, 0, 0, Buffer.from(wasm.data), transactionOptions).then(trx => {
      //             eos.setabi(account.name, JSON.parse(Buffer.from(abi.data)), transactionOptions).then(trx => {
      //                 // That's it!
      //                 console.log(`Transaction ID: ${trx.transaction_id}`);
         
      //                 setTimeout(function(){
      //                   eos.contract(account.name).then(contract => {  // contract account needs to change when going to jungle..
      //                     contract.create(account.name, 1, '110.00', '210.00', '140.00', '100.00', 'cool place', transactionOptions)
      //                 }).catch(e => {
      //                     console.log("error", e);
      //                 })
      //                 }, 2000)

                 
      //             }).catch(error => {
      //                 console.error(error);
      //             });
      //               console.log(`Transaction ID: ${trx.transaction_id}`);
      //           }).catch(error => {
      //               console.error(error);
      //           });

      //       }).catch(error => {
      //           // The user rejected this request, or doesn't have the appropriate requirements.
      //           console.error(error);
      //       });
      //   }))
      // },
      // secureTokenDeploy: function () {
      //   let wasm
      //   let abi

      //   axios
      //     .get('http://127.0.0.1:3001/getTokenWasm')
      //     .then(response => (wasm = response))
      //     .then(axios.get('http://127.0.0.1:3001/getTokenAbi')
      //     .then(response => (abi = response)))
      //     .then(ScatterJS.scatter.connect('My-App').then(connected => {

      //       // If the user does not have Scatter or it is Locked or Closed this will return false;
      //       if(!connected) return false;

      //       const scatter = ScatterJS.scatter;

      //       // Now we need to get an identity from the user.
      //       // We're also going to require an account that is connected to the network we're using.
      //       const requiredFields = { accounts:[network] };
      //       scatter.getIdentity(requiredFields).then(() => {

      //           // Always use the accounts you got back from Scatter. Never hardcode them even if you are prompting
      //           // the user for their account name beforehand. They could still give you a different account.
      //           const account = scatter.identity.accounts.find(x => x.blockchain === 'eos');

      //           // You can pass in any additional options you want into the eosjs reference.
      //           const eosOptions = { expireInSeconds:60 };

      //           // Get a proxy reference to eosjs which you can use to sign transactions with a user's Scatter.
      //           const eos = scatter.eos(network, Eos, eosOptions);

      //           // ----------------------------
      //           // Now that we have an identity,
      //           // an EOSIO account, and a reference
      //           // to an eosjs object we can send a transaction.
      //           // ----------------------------


      //           // Never assume the account's permission/authority. Always take it from the returned account.
      //           const transactionOptions = { authorization:[`${account.name}@${account.authority}`] };

              
         
      //           console.log(wasm)
      //           console.log(abi)

      //           // wasm = eos.fc.types.bytes().fromObject(Buffer.from(wasm))

      //           // eos.fc.types.bytes().fromObject(wasm)
      //           //  eos.contract(account.name).then(contract => {  // contract account needs to change when going to jungle..
      //           //     contract.create(account.name, 1, '110.00', '210.00', '140.00', '100.00', 'cool place', transactionOptions)
      //           // }).catch(e => {
      //           //     console.log("error", e);
      //           // })

      //           //  eos.contract(account.name).then(contract => {  // contract account needs to change when going to jungle..
      //           //     contract.update(account.name, 1, '110.00', '210.00', '140.00', '100.00', 'cool place', transactionOptions)
      //           // }).catch(e => {
      //           //     console.log("error", e);
      //           // })

      //           eos.setcode(account.name, 0, 0, Buffer.from(wasm.data), transactionOptions).then(trx => {
      //             eos.setabi(account.name, JSON.parse(Buffer.from(abi.data)), transactionOptions).then(trx => {
      //                 // That's it!
      //                 console.log(`Transaction ID: ${trx.transaction_id}`);
      //               eos.contract(account.name).then(contract => {  // contract account needs to change when going to jungle..
      //                 console.log(contract)
      //                 contract.create(account.name,'1000000.0000 CUR', transactionOptions)
      //               }).catch(e => {
      //                 console.log("error", e);
      //               })
      //             }).catch(error => {
      //                 console.error(error);
      //             });
      //               console.log(`Transaction ID: ${trx.transaction_id}`);
      //           }).catch(error => {
      //               console.error(error);
      //           });

      //       }).catch(error => {
      //           // The user rejected this request, or doesn't have the appropriate requirements.
      //           console.error(error);
      //       });
      //   }))
      // }
    }
  }
</script>